import type { RouterOptions } from "@nuxt/schema";

// https://router.vuejs.org/api/interfaces/routeroptions.html
export default <RouterOptions>{
  routes: (_routes) => {
    const { ssrContext } = useNuxtApp();

    const subdomain = useSubdomain();

    // Determine subdomain on both server and client
    let currentSubdomain = "";
    let currentHost = "";

    if (import.meta.server && ssrContext?.event) {
      // Server-side: use ssrContext (always read currentHost, even if subdomain is empty)
      currentSubdomain = ssrContext.event.context.subdomain || "";
      currentHost = ssrContext.event.context.currentHost || "";
    } else if (import.meta.client) {
      // Client-side: parse from window.location.hostname
      const hostname = window.location.hostname;
      currentHost = hostname;
      const parts = hostname.split(".");
      if (parts.length > 1 && parts[0] !== "localhost") {
        currentSubdomain = parts[0];
      }
    }

    if (currentSubdomain.includes("student")) {
      subdomain.value = "students";
    }

    if (
      currentSubdomain.includes("companion") ||
      currentHost.includes("iewwritingcompanion")
    ) {
      subdomain.value = "companion";
    }

    // Check for companion routes (subdomain or full domain)
    if (
      currentSubdomain.includes("companion") ||
      currentHost.includes("iewwritingcompanion")
    ) {
      var companionRoutes = _routes.filter((i) =>
        i.path.includes("/companion")
      );

      const companionRouteMapped = companionRoutes.map((i) => {
        return {
          ...i,
          path:
            i.path === "/companion" ? "/" : i.path.replace("/companion/", "/"),
        };
      });

      // Sort routes so static routes come before dynamic routes
      companionRouteMapped.sort((a, b) => {
        const aIsDynamic = a.path.includes(":");
        const bIsDynamic = b.path.includes(":");

        // Static routes come first
        if (!aIsDynamic && bIsDynamic) return -1;
        if (aIsDynamic && !bIsDynamic) return 1;
        return 0;
      });

      return companionRouteMapped;
    }

    if (currentSubdomain.includes("student")) {
      var studentRoutes = _routes.filter((i) => i.path.includes("/students"));

      const studentRouteMapped = studentRoutes.map((i) => {
        return {
          ...i,
          path:
            i.path === "/students"
              ? i.path.replace("/students", "")
              : i.path.replace("/students/", "/"),
        };
      });

      return studentRouteMapped;
    }
  },
};
